module.exports = __webpack_public_path__ + "media/images/application/template/logoslider/logo-bellway-2835c3549ea343a7dde6f5548e7521f0.png";